<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Question File -->
      <b-form-group
        label="1 - Question File"
        label-for="question_file"
      >
        <b-form-file
          id="question_file"
          v-model="question_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Question Option File -->
      <b-form-group
        label="2 - Question Option File"
        label-for="question_option_file"
      >
        <b-form-file
          id="question_option_file"
          v-model="question_option_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Question Option Point File -->
      <b-form-group
        label="3 - Question Option Point File"
        label-for="question_option_point_file"
      >
        <b-form-file
          id="question_option_point_file"
          v-model="question_option_point_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Score Definition File -->
      <b-form-group
        label="4 - Score Definition File"
        label-for="score_definition_file"
      >
        <b-form-file
          id="score_definition_file"
          v-model="score_definition_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Score Definition Question File -->
      <b-form-group
        label="5 - Score Definition Question File"
        label-for="score_definition_question_file"
      >
        <b-form-file
          id="score_definition_question_file"
          v-model="score_definition_question_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Score Definition Target File -->
      <b-form-group
        label="5.2 - Score Definition Target File"
        label-for="score_definition_target_file"
      >
        <b-form-file
          id="score_definition_target_file"
          v-model="score_definition_target_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Data File -->
      <b-form-group
        label="6 - Data File"
        label-for="data_file"
      >
        <b-form-file
          id="data_file"
          v-model="data_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

      <!-- Data MP File -->
      <b-form-group
        label="7 - Data MP File"
        label-for="data_mp_file"
      >
        <b-form-file
          id="data_mp_file"
          v-model="data_mp_file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-form-group>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BFormFile,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationObserver,
    BFormGroup,
    BForm,
    BFormFile,
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      question_file: null,
      question_option_file: null,
      question_option_point_file: null,
      score_definition_file: null,
      score_definition_question_file: null,
      score_definition_target_file: null,
      data_file: null,
      data_mp_file: null,
      required,
    }
  },
  methods: {
    calculateScores() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Score Calculation',
          icon: 'CoffeeIcon',
          variant: 'success',
          text: 'Score calculation process started...',
        },
      })

      useJwt.axiosIns.get(`project/CalculateScores/${this.projectId}`)
        .then(() => {
        })
        .catch(e => {
          console.log(e)
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success && (this.question_file || this.question_option_file || this.question_option_point_file || this.score_definition_file || this.score_definition_question_file || this.score_definition_target_file || this.data_file || this.data_mp_file)) {
          // question file

          const formData = new FormData()
          formData.append('ProjectId', this.projectId)
          formData.append('QuestionFile', this.question_file)
          formData.append('QuestionOptionFile', this.question_option_file)
          formData.append('QuestionOptionPointFile', this.question_option_point_file)
          formData.append('ScoreDefinitionFile', this.score_definition_file)
          formData.append('ScoreDefinitionQuestionFile', this.score_definition_question_file)
          formData.append('ScoreDefinitionTargetFile', this.score_definition_target_file)
          formData.append('DataFile', this.data_file)
          formData.append('DataMpFile', this.data_mp_file)

          useJwt.axiosIns.post('project/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(response => {
              if (response.data) {
                if (response.data === 'Ok') {
                  if (this.data_file) {
                    this.calculateScores()
                  }
                  this.$emit('success')
                } else {
                  this.$emit('error', response.data)
                }
                this.question_file = null
                this.question_option_file = null
                this.question_option_point_file = null
                this.score_definition_file = null
                this.score_definition_question_file = null
                this.score_definition_target_file = null
                this.data_file = null
                this.data_mp_file = null
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.$emit('error', 'Select a file!')
        }
      })
    },
  },
}
</script>
